import { createClient } from '@supabase/supabase-js'

/**
 * Supabase Client Configuration
 * 
 * IMPORTANT: OAuth Configuration Requirements
 * 1. Supabase Site URL (in Supabase Dashboard > Authentication > URL Configuration):
 *    - Should be set to frontend root (e.g., http://localhost:5173 or https://saloon.aibitsoft.com)
 * 
 * 2. Redirect URLs (in Supabase Dashboard > Authentication > URL Configuration):
 *    - Add: http://localhost:5173 (for development)
 *    - Add: https://saloon.aibitsoft.com (for production)
 * 
 * 3. detectSessionInUrl: true
 *    - Enables automatic session detection from URL hash fragments
 *    - Supabase will automatically process OAuth tokens from the URL
 *    - AuthContext calls getSession() on app startup to detect the session
 */

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // Automatically detects and processes OAuth sessions from URL
    storage: window.localStorage,
    flowType: 'pkce', // Use PKCE flow for better security and OAuth compatibility
  },
})

export default supabase
